import {createSelector} from 'reselect';
import {getCancellationPolicy as cancellationPolicyStore, getTripData} from './store';
import {getListingIds, getSuperlativeBadges} from './listing';
import {getListingOverviewBadges} from './listingOverviewBadges';
import {getNldBadge} from './badges';

const getCheckoutSelectedData = createSelector(
    [getListingIds, getTripData],
    (listing, tripData) => ({
        adult_count: tripData.adults.toString(),
        child_count: tripData.children.toString(),
        date_end: tripData.departDateText,
        date_start: tripData.arriveDateText,
        listing_id: listing.listingId,
        with_pets: `${tripData.hasPets}`
    })
);
const getPropertyDetailsData = createSelector(
    [getListingIds],
    (listing) => ({
        listing_id: listing.listingId
    })
);

const getCancellationPolicy = createSelector(
    [cancellationPolicyStore],
    ({policyType}) => {
        switch (policyType) {
            case 'STRICT':
                return 'Strict';
            case 'FIRM':
                return 'Firm';
            case 'MODERATE':
                return 'Moderate';
            case 'RELAXED':
                return 'Relaxed';
            case 'FLEXIBLE':
                return 'Custom(IPM)';
            case 'NO_REFUND':
                return 'No_Refund';
            default:
                return 'Other';
        }
    }
);

const getPropertySummaryPresented = createSelector(
    [
        getListingIds,
        getTripData,
        getListingOverviewBadges,
        getNldBadge,
        getSuperlativeBadges,
        getCancellationPolicy
    ],
    (listing, tripData, rankedBadges, nldBadge, superlativeBadge, cancellationPolicy) => ({
        adultCount: tripData.adults,
        childCount: tripData.children,
        dateEnd: tripData.departDateText,
        dateStart: tripData.arriveDateText,
        listingId: listing.listingId,
        hasPets: tripData.hasPets,
        rankedBadges,
        nldBadge,
        superlativeBadge,
        cancellationPolicy
    })
);

const getUxPropertyDetailsNavigationSelectedData = createSelector(
    [getListingIds],
    (listing) => ({
        listing_id: listing.listingId
    })
);

const getPropertyDetailsDataWithCancellationPolicy = createSelector(
    [getListingIds, getCancellationPolicy],
    (listing, cancellationPolicy) => ({
        listing_id: listing.listingId,
        cancellation_policy: cancellationPolicy
    })
);

export {
    getPropertySummaryPresented,
    getCheckoutSelectedData,
    getPropertyDetailsData,
    getUxPropertyDetailsNavigationSelectedData,
    getPropertyDetailsDataWithCancellationPolicy,
    getCancellationPolicy
};
